import { UserOutlined } from "@ant-design/icons";
import { Button, Card, Col, Form, message, Row, Space, Typography } from "antd";
import React, { useEffect, useMemo, useState } from "react";
import { ErrorBoundary } from "react-error-boundary";
import { useDispatch, useSelector } from "react-redux";
import { NavLink, useHistory, useLocation } from "react-router-dom";
import BasicLayout from "../../../components/BasicLayout";
import Center from "../../../components/common/Center";
import FallBack from "../../../components/common/FallBack/FallBack";
import Notification from "../../../components/common/Notification";
import InputField from "../../../components/Form/InputField";
import { useUpdateReason } from "../../../components/Hooks/useUpdateReason";
import {
	addTechnicalSpecification,
	getSingleTechnicalSpecification,
	updateTechnicalSpecification,
} from "../../../store/actions/products/technicalspecifications/technicalspecification.action";

const TechnicalSpecificationForm = (props) => {
	const history = useHistory();
	const dispatch = useDispatch();
	const location = useLocation();
	const softdelete = new URLSearchParams(location.search).get("soft-delete");

	const { Title } = Typography;
	const [form] = Form.useForm();
	const { modelToggle, UpdateModel } = useUpdateReason();
	const [onFinishValues, setOnFinishValues] = useState();
	const technicalspecification = useSelector(
		(state) => state.technicalspecification.technicalspecification
	);

	const technicalspecificationId = +props.match.params.id;

	const currentLocation = props.location.pathname;

	const handleError = (error) => {
		message.error(error.message);
	};
	useEffect(() => {
		if (technicalspecificationId) {
			dispatch(getSingleTechnicalSpecification(technicalspecificationId, softdelete)).catch(
				(err) => {
					Notification("error", err, "", "topRight");
					history.push("/products/technicalspecifications");
				}
			);
		}
	}, [technicalspecificationId, history, softdelete, dispatch]);

	const Rules = [
		{
			required: true,
		},
	];

	const onFinish = async (values) => {
		try {
			if (currentLocation === "/products/technicalspecifications/add") {
				await dispatch(addTechnicalSpecification({ ...values }));
				history.push("/products/technicalspecifications");
				return;
			}
			setOnFinishValues(values);
			await modelToggle(true);
		} catch (err) {
			if (err.message) {
				return Notification("error", "Error Occurred", err.message, "topRight");
			}
			const errorMessage = err.message
				? err.message
				: (err?.response && err.response?.data?.message) || "Soemthing went wrong";
			return Notification("error", "", errorMessage);
		}
	};

	const defaultValues = useMemo(
		() => ({
			name: technicalspecificationId ? technicalspecification.name : "",
		}),
		[technicalspecificationId, technicalspecification.name]
	);

	useEffect(() => {
		form.setFieldsValue(defaultValues);
	}, [form, defaultValues]);

	const handleCancel = () => {
		Notification("info", "Job action has been cancelled", "", "topRight");
	};
	return (
		<BasicLayout accessLevel={props.accessLevel}>
			<ErrorBoundary FallbackComponent={FallBack} onError={handleError}>
				<Row type="flex" justify="center" align="middle" id="form-container">
					<Center height="4rem">
						{technicalspecificationId ? (
							<Title level={2} className="update-or-add-title">
								Update Technical Specification
							</Title>
						) : (
							<Title level={2} className="update-or-add-title">
								Add New Technical Specification
							</Title>
						)}
					</Center>
					<Col>
						<Card className="form-card">
							<Form
								form={form}
								name="basic"
								layout="vertical"
								onFinish={onFinish}
								initialValues={defaultValues}
							>
								<InputField
									rules={Rules}
									label="Name"
									name="name"
									placeholder="Please enter technical specification"
									prefix={<UserOutlined />}
								/>
								<UpdateModel
									id={technicalspecificationId}
									action={updateTechnicalSpecification}
									valuesWithoutReason={onFinishValues}
									redirectUrl="/products/technicalspecifications"
									placeholder="Enter reason for update technical specification"
								/>
								<Form.Item style={{ marginTop: "20px" }}>
									<Center height="0px">
										<Space>
											<NavLink to="/products/technicalspecifications">
												<Button danger type="primary" onClick={handleCancel}>
													Cancel
												</Button>
											</NavLink>
											<Button type="primary" htmlType="submit">
												{technicalspecificationId ? "Update" : "Add"}
											</Button>
										</Space>
									</Center>
								</Form.Item>
							</Form>
						</Card>
					</Col>
				</Row>
			</ErrorBoundary>
		</BasicLayout>
	);
};

export default TechnicalSpecificationForm;
